import { render, staticRenderFns } from "./WarningRightExample.vue?vue&type=template&id=1abf3762&scoped=true&"
import script from "./WarningRightExample.vue?vue&type=script&lang=js&"
export * from "./WarningRightExample.vue?vue&type=script&lang=js&"
import style0 from "./WarningRightExample.vue?vue&type=style&index=0&id=1abf3762&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abf3762",
  null
  
)

export default component.exports